const scripts = {
  overview: import("./overview"),
  event: import("./event"),
  article: import("./article"),
  directory: import("./directory"),
  location: import("./location"),
};

export default scripts;
